import { render, staticRenderFns } from "./ModalQuestionsAnswersRejected.vue?vue&type=template&id=664d44dc"
import script from "./ModalQuestionsAnswersRejected.vue?vue&type=script&lang=js"
export * from "./ModalQuestionsAnswersRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports